var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOwner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86999 8.5C2.92499 8.255 2.82499 7.905 2.64999 7.73L1.43499 6.515C1.05499 6.135 0.904991 5.73 1.01499 5.38C1.12999 5.03 1.48499 4.79 2.01499 4.7L3.57499 4.44C3.79999 4.4 4.07499 4.2 4.17999 3.995L5.03999 2.27C5.28999 1.775 5.62999 1.5 5.99999 1.5C6.36999 1.5 6.70999 1.775 6.95999 2.27L7.81999 3.995C7.88499 4.125 8.01999 4.25 8.16499 4.335L2.77999 9.72C2.70999 9.79 2.58999 9.725 2.60999 9.625L2.86999 8.5Z",
    fill: "#2266EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34999 7.72995C9.16999 7.90995 9.06999 8.25495 9.12999 8.49995L9.47499 10.0049C9.61999 10.6299 9.52999 11.0999 9.21999 11.3249C9.09499 11.4149 8.94499 11.4599 8.76999 11.4599C8.51499 11.4599 8.21499 11.3649 7.88499 11.1699L6.41999 10.2999C6.18999 10.1649 5.80999 10.1649 5.57999 10.2999L4.11499 11.1699C3.55999 11.4949 3.08499 11.5499 2.77999 11.3249C2.66499 11.2399 2.57999 11.1249 2.52499 10.9749L8.60499 4.89495C8.83499 4.66495 9.15999 4.55995 9.47499 4.61495L9.97999 4.69995C10.51 4.78995 10.865 5.02995 10.98 5.37995C11.09 5.72995 10.94 6.13495 10.56 6.51495L9.34999 7.72995Z",
    fill: "#2266EF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwner);
export default __webpack_public_path__ + "static/media/owner.6197d3b6.svg";
export { ForwardRef as ReactComponent };